var classof = require('./_classof');
var ITERATOR = require('./_wks')('iterator');
var Iterators = require('./_iterators');
module.exports = require('./_core').isIterable = function (it) {
  var O = Object(it);
  return O[ITERATOR] !== undefined
    || '@@iterator' in O
    // eslint-disable-next-line no-prototype-builtins
    || Iterators.hasOwnProperty(classof(O));
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/library/modules/core.is-iterable.js
 ** module id = 2524
 ** module chunks = 0
 **/